import React from 'react';

const RichTextEditor = ({ value, onChange, placeholder, minHeight = '180px' }) => {
  const isShort = minHeight === '60px';

  if (isShort) {
    return (
      <input
        type="text"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || ''}
        style={{
          width: '100%',
          padding: '8px 12px',
          border: '1px solid #d1d5db',
          borderRadius: '6px',
          fontSize: '14px',
          lineHeight: '1.5',
          fontFamily: 'inherit',
        }}
      />
    );
  }

  return (
    <textarea
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder || ''}
      rows={4}
      style={{
        width: '100%',
        minHeight: minHeight || '120px',
        padding: '10px 12px',
        border: '1px solid #d1d5db',
        borderRadius: '6px',
        fontSize: '14px',
        lineHeight: '1.6',
        fontFamily: 'inherit',
        resize: 'vertical',
      }}
    />
  );
};

export default RichTextEditor;
